export const rolesIDs = ['user', 'dealer', 'guest']

export type RolesUnion = typeof rolesIDs[number]

export type RoleProps = {
  role?: RolesUnion | any
}

export const ROLES: Record<RolesUnion, string> = {
  user: 'user',
  guest: 'guest',
  dealer: 'dealer'
} as const
